import { getEnumValues } from './get-enum-values';
export enum OrganizationType{
	University='University',
	Club='Club',
	Academy='Academy',
}
export const OrganizationTypeValues = getEnumValues<OrganizationType>(OrganizationType);
